import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteSmartListMutation } from 'shared/hooks/queries/use-delete-smart-list-mutation';
import { useUser } from 'shared/hooks/use-user';
import { Paths } from 'shared/routes/paths';
import { SmartList } from 'shared/types/smart-list';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

export const useDeleteSmartList = () => {
  const user = useUser();
  const { mutateAsync, isPending } = useDeleteSmartListMutation();
  const { pathname: activePath } = useLocation();
  const navigate = useNavigate();

  const submit = useCallback(
    async (smartList: SmartList) => {
      if (!user) {
        return;
      }

      await mutateAsync({
        uid: user.uid,
        smartListId: smartList.id,
      });

      const smartListUrl = replaceUrlParams(Paths.SmartListDetail, {
        id: smartList.id,
      });

      if (smartListUrl === activePath) {
        navigate(Paths.AllTasks);
      }
    },
    [activePath, mutateAsync, navigate, user],
  );

  return { submit, isPending };
};
